export default {
    test:"test ok",
    home:{
        upcomingmeetup:[
            {
                id:"1",    
                isUpcoming:true,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
            {
                id:"2",    
                isUpcoming:true,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"2"
            },
            {
                id:"3",    
                isUpcoming:true,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"2"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ]
 
    },
    itandxpdigitale:{
        upcomingmeetup:[
            {
                id:"1",    
                isUpcoming:true,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
            {
                id:"2",    
                isUpcoming:true,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"1"
            },
            {
                id:"3",    
                isUpcoming:true,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"1"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ] 
    },
    infrastructure:{
        upcomingmeetup:[
            {
                id:"1",    
                isUpcoming:true,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"2"
            },
            {
                id:"2",    
                isUpcoming:true,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"2"
            },
            {
                id:"3",    
                isUpcoming:true,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"2"
            },
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"2"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"2"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"2"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ]   
    },
    dataandia:{
        upcomingmeetup:[
            {
                id:"1",    
                isUpcoming:true,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
            {
                id:"2",    
                isUpcoming:true,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"3"
            },
            {
                id:"3",    
                isUpcoming:true,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"3"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ]   
    },
    si:{
        upcomingmeetup:[
            {
                id:"1",    
                isUpcoming:true,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"4"
            },
            {
                id:"2",    
                isUpcoming:true,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"4"
            },
            {
                id:"3",    
                isUpcoming:true,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"4"
            },
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"4"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"4"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"4"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ]
    },
    ingenierie:{
        upcomingmeetup:[
            
        ],
        pastmeetup:[
            {
                id:"1",    
                isUpcoming:false,
                dateDay:"24",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"5"
            },
            {
                id:"2",    
                isUpcoming:false,
                dateDay:"23",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"5"
            },
            {
                id:"3",    
                isUpcoming:false,
                dateDay:"22",
                dateMonth:"juin",
                theme:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"5"
            },
        ],
        meetupsCalendar:[
            {
                id: 1,
                description: 'Meetup sur le projet A.',
                date: new Date(2021, 5, 15),
                isCompleted: false   
            },
            {
                id: 2,
                description: 'Meetup sur le projet B.',
                date: new Date(2021, 6, 23),
                isCompleted: false  
            },
            {
                id: 3,
                description: 'Meetup sur le projet C.',
                date: new Date(2021, 6, 27),
                isCompleted: false
            }
        ]   
    },
    admin:{
        meetuplist:[
            {
                id:"1",    
                isUpcoming:true,
                date:"22/07/2021",
                title:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"1",
                typeTextFr:"DIGITAL & DATA",
                typeTextEn:"DIGITAL & DATA"
            },
            {
                id:"2",    
                isUpcoming:true,
                date:"22/07/2021",
                title:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"3",
                stateText:"Confirmé",
                type:"2",
                typeTextFr:"TELECOM & INFRA",
                typeTextFr:"Infrastructure & cybersecurity"
            },
            {
                id:"3",    
                isUpcoming:true,
                date:"22/07/2021",
                title:"Design & Ergonomie: réinventons ensemble, les usages de demain",
                chairpersons:"Franck GR et Dawid SZ",
                beginningHour:"12h30",
                endHour:"13h30",
                state:"1",
                stateText:"Débutant",
                type:"3",
                typeTextFr:"dataandia",
                typeTextFr:"dataandia"
            },
        ],
        optionsAccess:{
            fr:[
                {
                    id:"1",
                    type:"Débutant"
                },
                {
                    id:"2",
                    type:"Intermédiaire"
                },
                {
                    id:"3",
                    type:"Confirmé"
                }
            ],
            en:[
                {
                    id:"1",
                    type:"Beginner"
                },
                {
                    id:"2",
                    type:"Intermediate"
                },
                {
                    id:"3",
                    type:"Confirmed"
                }
            ]
        }
    }
}